module.exports = __webpack_public_path__ + "img/cover-slot-bg.1640d7c7.png";